import React, { useState } from "react";
import { Spinner } from "@chakra-ui/react";
import { Button } from "components/RFQ/Button";
import { CustomModal } from "components/RFQ/Modal/CustomModal";

type DeleteConfirmationModalProps = {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: () => Promise<void>;
	templateName?: string;
};

export const DeleteConfirmationModal = ({
	isOpen,
	onClose,
	onConfirm,
	templateName,
}: DeleteConfirmationModalProps) => {
	const [isLoading, setIsLoading] = useState(false);

	const dialogProperty = {
		icon: "trash-03" as const,
		bgColor: "bg-utility-error-50",
		iconColor: "text-utility-error-500",
		title: "Delete Template",
		description: `Are you sure you want to delete ${templateName ? `"${templateName}"` : "this template"}? This action cannot be undone.`,
	};

	const handleConfirm = async () => {
		setIsLoading(true);
		try {
			await onConfirm();
			onClose();
		} catch (error) {
			console.error("Delete confirmation error:", error);
		} finally {
			setIsLoading(false);
		}
	};

	const FooterComponent = () => {
		return (
			<div className="flex w-full justify-between gap-2">
				<Button
					onClick={onClose}
					btntype="base"
					className="!w-full"
					disabled={isLoading}
				>
					Cancel
				</Button>
				<Button
					danger={true}
					className="flex !w-full gap-3"
					onClick={handleConfirm}
					disabled={isLoading}
					data-testid="confirm-delete-button"
				>
					{isLoading ? <Spinner size="sm" /> : "Delete"}
				</Button>
			</div>
		);
	};

	return (
		<CustomModal
			onClose={onClose}
			isOpen={isOpen}
			header={dialogProperty}
			size="md"
			footerComponent={<FooterComponent />}
		>
			<div className="py-2">
				<p className="text-sm text-gray-600">
					This template will be permanently removed from your account. Any RFx
					created with this template will not be affected.
				</p>
			</div>
		</CustomModal>
	);
};
